import { render, staticRenderFns } from "./ShopStart.vue?vue&type=template&id=2415bf66&"
import script from "./ShopStart.vue?vue&type=script&lang=js&"
export * from "./ShopStart.vue?vue&type=script&lang=js&"
import style0 from "./ShopStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports